module.exports = __webpack_public_path__ + "img/violet-allen.ab2b65c5.png";